import type { Metadata } from 'next'
import type { Locale } from '@/context/LangContext'
import { seo, type SeoEntry } from '@/data/seo'

export const siteUrl = 'https://lexoya.com'
export const defaultLang: Locale = 'fa'

export function getLocale(lang: string): Locale {
  return lang === 'en' || lang === 'fa' || lang === 'ar' ? lang : defaultLang
}

export function localizedPath(lang: string, path: string): string {
  // The homepage is /{lang}, not /{lang}/home. `pageMetadata(lang, 'home')` is
  // how the home route asks for its canonical/hreflang, so strip that slug here.
  const clean = path === 'home' ? '' : path
  return `/${lang}${clean ? `/${clean}` : ''}`
}

export function pageMetadata(lang: string, path: string, entry?: SeoEntry): Metadata {
  const l = getLocale(lang)
  const e = entry ?? seo[path]
  const url = localizedPath(l, path)
  return {
    title: e.title[l],
    description: e.description[l],
    alternates: {
      canonical: url,
      languages: {
        en: localizedPath('en', path),
        fa: localizedPath('fa', path),
        ar: localizedPath('ar', path),
        // x-default must point at *this page* in the default language, not at
        // the homepage — otherwise every page claims the same fallback URL.
        'x-default': localizedPath(defaultLang, path),
      },
    },
    openGraph: {
      title: e.title[l],
      description: e.description[l],
      url,
      siteName: 'Lexoya',
      locale: l === 'fa' ? 'fa_IR' : l === 'ar' ? 'ar_SA' : 'en_US',
      alternateLocale: ['en_US', 'fa_IR', 'ar_SA'],
      type: 'website',
    },
  }
}